"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeUp = void 0;
exports.timeUp = 100;
//# sourceMappingURL=helper.types.js.map